<div class="w-full [perspective:1000px]">
  <div class="relative w-full transition-transform duration-500 [transform-style:preserve-3d]"
       [style.transform]="isFlipped() ? 'rotateY(180deg)' : 'rotateY(0deg)'">

    <div
         class="w-full [backface-visibility:hidden] bg-component-inner border border-primary-border rounded-xl shadow-sm flex flex-col overflow-hidden min-h-[200px]">

      <div
           class="px-4 py-3 border-b border-secondary-border flex justify-between items-center bg-alt-background shrink-0">
        <span class="font-bold text-primary-text">{{ modelTitle() }}</span>

        <div class="flex items-center gap-2">
          @if (activeTemplate()) {
          <button (click)="openImproveModal()"
                  [title]="config.dataCard.improveWithAi"
                  class="text-primary hover:text-primary-text transition-colors focus:outline-none w-8 h-8 flex items-center justify-center rounded hover:bg-hover-default">
            <i class="fas fa-sparkles text-lg"></i>
          </button>
          }
          <button (click)="toggleFlip()"
                  [title]="config.dataCard.rawView"
                  class="text-secondary-text hover:text-primary transition-colors focus:outline-none w-8 h-8 flex items-center justify-center rounded hover:bg-hover-default">
            <i class="fa-regular fa-brackets-curly text-lg"></i>
          </button>
        </div>
      </div>

      <div class="p-4 flex-1">
        @if (isLoading()) {
        <div
             class="flex flex-col items-center justify-center p-8 border border-secondary-border rounded-xl bg-component-inner/50">
          <i class="fas fa-circle-notch fa-spin text-2xl text-primary mb-3"></i>
          <span class="text-sm font-medium text-secondary-text">{{ config.dataCard.loading }}</span>
        </div>
        } @else if (isGenerating()) {
        <div
             class="flex flex-col items-center justify-center p-8 border border-primary-border rounded-xl bg-primary/5 shadow-sm animate-pulse">
          <i class="fad fa-robot text-3xl text-primary mb-3"></i>
          <span class="text-sm font-semibold text-primary-text">{{ config.dataCard.generating }}</span>
        </div>
        } @else if (activeTemplate()) {
        <rapider-template-renderer [template]="activeTemplate()!"
                                   [data]="data">
        </rapider-template-renderer>
        } @else {
        <div
             class="text-secondary-text text-sm italic p-4 flex items-center gap-2 border border-secondary-border rounded-xl bg-component-inner">
          <i class="fas fa-info-circle text-warning"></i> {{ config.dataCard.noData }}
        </div>
        }
      </div>
    </div>

    <div
         class="absolute top-0 left-0 w-full h-full [backface-visibility:hidden] [transform:rotateY(180deg)] bg-component-inner border border-primary-border rounded-xl shadow-sm flex flex-col overflow-hidden">

      <div
           class="px-4 py-3 border-b border-secondary-border flex justify-between items-center bg-alt-background shrink-0">
        <div class="flex items-center gap-2">
          <i class="fas fa-file-alt text-primary"></i>
          <span class="font-bold text-primary-text">{{ config.texts.mainRecordDetails }}</span>
          @if (data?.id) {
          <nz-tag class="!m-0 font-mono border-secondary-border bg-component-inner">{{ data.id }}</nz-tag>
          }
        </div>
        <button (click)="toggleFlip()"
                [title]="config.dataCard.templateView"
                class="text-primary hover:text-secondary-text transition-colors focus:outline-none w-8 h-8 flex items-center justify-center rounded hover:bg-hover-default">
          <i class="fa-regular fa-layer-group text-lg"></i>
        </button>
      </div>

      <div class="p-4 flex-1 overflow-y-auto custom-scrollbar bg-component-inner">
        <rapider-json-viewer [data]="data"
                             [classMap]="diffClassMap"
                             [maxLineToDisplay]="20"
                             class="w-full block">
        </rapider-json-viewer>
      </div>
    </div>

  </div>

  <nz-modal [(nzVisible)]="isImproveModalVisible"
            [nzKeyboard]="false"
            [nzTitle]="config.dataCard.improveModalTitle"
            [nzFooter]="null"
            (nzOnCancel)="closeImproveModal()"
            nzWidth="600px">
    <ng-container *nzModalContent>
      <rapider-ai-prompt [description]="config.dataCard.improveModalDesc"
                         [placeholder]="config.dataCard.promptPlaceholder"
                         [submitText]="config.dataCard.sendButton"
                         [uploadText]="config.dataCard.uploadButton"
                         [cancelText]="config.dataCard.cancelButton"
                         [suggestions]="starterPrompts()"
                         [isSubmitting]="isImproving()"
                         (submitPrompt)="improveTemplateWithAi($event)"
                         (cancel)="closeImproveModal()">
      </rapider-ai-prompt>
    </ng-container>
  </nz-modal>

</div>